const isAWholeNumber = (number) => {
	if (number && number % 1 === 0) {
		return true;
	}
	return false;
};

export default isAWholeNumber;
